export default __webpack_public_path__ + "static/media/input-loader.dc63bf2e.svg";